import { Component, Input } from "@angular/core";
import { CouponCodeDisplayInfoDto } from "clearline-api";
import { CouponCodeDisplay } from "../validate-coupon.model";

@Component({
  selector: "app-validate-coupon-details",
  templateUrl: "./validate-coupon-details.component.html",
  styleUrls: ["./validate-coupon-details.component.scss"]
})
export class ValidateCouponDetailsComponent {
  @Input() set coupon(value: CouponCodeDisplay) {
    if (value) {
      this.generalDetails = this.extractDetails(0, value.info);
      this.additionalDetails = this.extractDetails(1, value.info);
      this.hasAdditionalDetails = Object.keys(this.additionalDetails).length > 0;
    }
  }

  protected generalDetails: Record<string, string> = {};
  protected additionalDetails: Record<string, string> = {};
  protected hasAdditionalDetails = false;

  private extractDetails(detailsIndex: number, info?: CouponCodeDisplayInfoDto[]): Record<string, string> {
    if (!info?.length) {
      return {};
    }

    return Object.entries(info[detailsIndex]?.items || {}).reduce((acc, [key, value]) => {
      acc[key] = value || "-";
      return acc;
    }, {});
  }
}
